import { render } from "./LotteryChoice.vue?vue&type=template&id=3700e358&scoped=true"
import script from "./LotteryChoice.vue?vue&type=script&lang=js"
export * from "./LotteryChoice.vue?vue&type=script&lang=js"

import "./LotteryChoice.vue?vue&type=style&index=0&id=3700e358&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3700e358"]])

export default __exports__